import React from 'react';
import { ComponentInfo } from '@components';
import { Box, Typography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { rem } from '@helpers';

export const TitleDocumentTermsConditionPlaceholder: React.FC = () => {
	const t = useTranslation();
	return (
		<ComponentInfo name="titleDocumentTermsCondition">
			<Box styles={{ marginBottom: rem(36) }}>
				<Typography appearance="headline-200-02">
					{t('placeholders.titleDocumentTermsCondition.title')}
				</Typography>
			</Box>
		</ComponentInfo>
	);
};
